import { render } from "./BlockedPlayerManager.vue?vue&type=template&id=c156291e"
import script from "./BlockedPlayerManager.vue?vue&type=script&lang=js"
export * from "./BlockedPlayerManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__